import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CourseGroup } from "../../interfaces/course-group";
import { ApiService } from "../api/api.service";

@Injectable({
  providedIn: "root",
})
export class OnboardingService {
  constructor(private apiService: ApiService) {}

  getOnboarding(): Observable<CourseGroup> {
    return this.apiService.getRequest<CourseGroup>("onboarding/");
  }
}
